var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGluten(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.43115 1.65374C1.65993 1.50866 1.92386 1.43769 2.19034 1.44959H35.1295C35.396 1.43769 35.6599 1.50866 35.8887 1.65374V35.4887C35.6599 35.6337 35.396 35.7047 35.1295 35.6929H2.19034C1.92387 35.7047 1.65995 35.6337 1.43115 35.4887L1.43115 1.65374Z",
    stroke: "#7ED957",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5437 5.1957C30.4216 5.07282 30.2583 5.00591 30.0892 5.00953C30.0395 5.01142 29.9901 5.01916 29.9419 5.03259C28.8693 5.26347 27.8746 5.79529 27.0629 6.57186C26.2354 7.7844 25.7505 9.21833 25.6645 10.7069C27.0684 10.513 28.3927 9.90288 29.4833 8.94755C30.1595 8.0393 30.5913 6.95643 30.7332 5.8132C30.754 5.70157 30.7476 5.5863 30.7144 5.47827C30.6812 5.37023 30.6225 5.27298 30.5437 5.1957Z",
    fill: "#7ED957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6071 5.68301C22.5461 5.58842 22.4632 5.51175 22.3663 5.46016C22.2694 5.40856 22.1615 5.38372 22.0528 5.38795C21.9441 5.39218 21.8381 5.42534 21.7446 5.48435C21.6511 5.54335 21.5733 5.62627 21.5183 5.72537C20.91 6.68768 20.559 7.80412 20.5024 8.95682C20.7291 10.4303 21.3488 11.804 22.2893 12.918C23.1574 11.7335 23.6893 10.315 23.8229 8.82762C23.6942 7.68214 23.2741 6.59572 22.6071 5.68301Z",
    fill: "#7ED957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.632 13.6002C29.7234 12.9653 28.668 12.6011 27.577 12.5461C26.1813 12.7899 24.8785 13.446 23.8203 14.4379C24.9381 15.3448 26.2788 15.8976 27.6863 16.0321C28.7712 15.8925 29.8012 15.4472 30.6678 14.7432C30.7576 14.6787 30.8305 14.5915 30.8797 14.4895C30.929 14.3875 30.9529 14.2742 30.9493 14.16C30.9457 14.0459 30.9148 13.9347 30.8593 13.8368C30.8038 13.7389 30.7256 13.6575 30.632 13.6002Z",
    fill: "#7ED957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4491 24.6555L13.4201 24.626L13.3932 24.5996C13.3602 24.5652 13.122 24.3084 12.7928 23.8941L6.02795 31.5399C5.94406 31.6348 5.87864 31.746 5.83543 31.8673C5.79222 31.9887 5.77206 32.1177 5.77611 32.247C5.78016 32.3763 5.80834 32.5035 5.85903 32.6211C5.90973 32.7388 5.98194 32.8447 6.07157 32.9327C6.16119 33.0208 6.26645 33.0894 6.38136 33.1344C6.49626 33.1795 6.61855 33.2003 6.74124 33.1955C6.86394 33.1907 6.98463 33.1605 7.09643 33.1066C7.20824 33.0527 7.30896 32.9761 7.39286 32.8813L14.1567 25.2355C13.7436 24.9193 13.4847 24.6827 13.4491 24.6555Z",
    fill: "#7ED957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4589 10.3863C18.3979 10.2917 18.3152 10.2151 18.2183 10.1635C18.1215 10.1119 18.0138 10.0871 17.9052 10.0913C17.7966 10.0956 17.6906 10.1287 17.5973 10.1877C17.5039 10.2467 17.4262 10.3296 17.3713 10.4286C17.088 10.9297 16.8482 11.4566 16.655 12.0029L19.4961 14.7943C19.6181 14.385 19.6779 13.9582 19.6733 13.5297C19.5448 12.3847 19.1252 11.2986 18.4589 10.3863Z",
    fill: "#7ED957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7011 16.1988C12.3838 16.8787 12.213 17.6237 12.2009 18.3802C12.4275 19.8534 13.0468 21.2269 13.9868 22.3406C14.6967 21.3177 15.2025 20.1543 15.4736 18.921L12.7011 16.1988Z",
    fill: "#7ED957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4869 18.3039C25.5781 17.6682 24.5222 17.3036 23.4309 17.2486C23.0255 17.2737 22.6263 17.3663 22.2479 17.5228L25.0847 20.3097C25.5872 20.0687 26.0682 19.7804 26.5218 19.4482C26.6116 19.3837 26.6846 19.2963 26.7338 19.1942C26.783 19.0921 26.807 18.9787 26.8034 18.8644C26.7998 18.7501 26.7688 18.6388 26.7133 18.5408C26.6578 18.4428 26.5806 18.3612 26.4869 18.3039Z",
    fill: "#7ED957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6438 22.0613C17.4977 22.4316 16.434 23.043 15.5173 23.8584C16.6352 24.7662 17.9761 25.3198 19.384 25.4546C20.0979 25.3893 20.7899 25.1583 21.4103 24.7782L18.6438 22.0613Z",
    fill: "#7ED957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3618 35.4805L2.45932 1.9079",
    stroke: "#7ED957",
    strokeWidth: 1.6,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.659668 0.634003)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGluten);
export default __webpack_public_path__ + "static/media/gluten.64b4dcba3c5cfa05838754cb67376c79.svg";
export { ForwardRef as ReactComponent };